import { render, staticRenderFns } from "./DrugOrderNotesDlg.vue?vue&type=template&id=697cf24d&"
import script from "./DrugOrderNotesDlg.vue?vue&type=script&lang=js&"
export * from "./DrugOrderNotesDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports